import { atom } from "recoil";
import { StandardInfo } from "../type/StandardInterface";

export const addStateStandard = atom({
  key: "addStateStandard",
  default: false,
});
export const editStateStandard = atom({
  key: "editStateStandard",
  default: false,
});
export const rowEditIdStateStandard = atom({
  key: "rowEditId",
  default: null,
});
export const disableButtonStateStandard = atom({
  key: "disableButtonStateStandard",
  default: false,
});

export const selectedRowsStateStandard = atom<StandardInfo[]>({
  key: "selectedRowsStateStandard",
  default: [],
});

export const filterText = atom({
  key: "setFilterTextState",
  default: "",
});

export const selectedRowsToDelete = atom< undefined | []>({
  key: "selectedRowsToDelete",
  default: [],
});

export const rowForEditStandard = atom<StandardInfo | undefined>({
  key: "rowForEditStandard",
  default: undefined,
});

export const standardSaving = atom({
  key: "StandardSaving",
  default: false,
});